var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative flex backdrop"},[_vm._l((_vm.raid),function(player,index){return _c('StreamCharacter',{key:index,attrs:{"player":player}})}),(!_vm.noLamp)?_c('StreamLamp'):_vm._e(),_c('StreamPet')],2)}
var staticRenderFns = []

export { render, staticRenderFns }